import * as React from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton, DialogProps, Typography } from '@mui/material';
import Close from '@mui/icons-material/Close';
interface ResponsiveDialogProps {
  title: string;
  subTitle:string;
  setOpenDialog: any;
  openDialog: boolean;
  customWidth?:number;
  children: React.ReactNode;
}

const ResponsiveDialog = ({ title,subTitle,customWidth, openDialog, setOpenDialog, children }: ResponsiveDialogProps) => {

  const [maxWidth] = React.useState<DialogProps['maxWidth']>(false);

  return (
    <Dialog
      open={openDialog}
      maxWidth={maxWidth}
      onClose={() => setOpenDialog('')}
    >
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant="h5">
          {title}
        </Typography>
        <Typography variant="h5">
          {subTitle}
        </Typography>
        <IconButton onClick={() => setOpenDialog('')}>
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {children}
      </DialogContent>
    </Dialog>
  );
}

export default ResponsiveDialog;